module.exports = __webpack_public_path__ + "DINNextLTPro-UltraLightCond.woff?92e6ddaa02f0088b41e65434a246d93d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-UltraLightCond.woff
// module id = 1386
// module chunks = 0